import React, { useEffect, useState } from 'react';
import { HourglassIcon } from 'lucide-react';
const TOTAL_SECONDS = 22 * 60 + 22;
function useCountdown(initialSeconds: number) {
  const [seconds, setSeconds] = useState(initialSeconds);
  useEffect(() => {
    const id = setInterval(() => setSeconds(s => s > 0 ? s - 1 : 0), 1000);
    return () => clearInterval(id);
  }, []);
  return {
    mm: Math.floor(seconds / 60),
    ss: seconds % 60
  };
}
function Unit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <span className="inline-flex items-baseline gap-1.5" data-id="element-99" data-mp="k30youdzwkkr">
      <span className="font-display text-2xl font-black tabular-nums tracking-wide text-white sm:text-3xl" style={{
      fontFamily: 'Montserrat, sans-serif',
      fontSize: "20px"
    }} data-id="element-100" data-mp="5d39qc88rqui">
        {String(value).padStart(2, '0')}
      </span>
      <span className="text-[10px] font-bold uppercase tracking-widest text-white/70 sm:text-xs" data-id="element-101" data-mp="3shj2ul0tffz3">{label}</span>
    </span>;
}
export function OfferBar() {
  const {
    mm,
    ss
  } = useCountdown(TOTAL_SECONDS);
  return <div role="region" aria-label="Compte à rebours de l'offre" className="fixed inset-x-0 top-0 z-50 border-b-2 border-blush bg-plum text-white shadow-[0_6px_20px_-10px_rgba(11,18,32,0.7)]" data-id="element-102" data-mp="qy0ie7ise9cz">
      <div className="mx-auto flex max-w-5xl items-center justify-between gap-4 px-4 py-3 sm:px-6" style={{
      paddingTop: "5px",
      paddingBottom: "6px",
      width: "374px",
      height: "40px",
      paddingRight: "35px"
    }} data-id="element-103" data-mp="10wq2m6y5o5we">
        <p className="flex items-center gap-2.5 text-[13px] font-extrabold uppercase leading-tight tracking-[0.18em] sm:text-base sm:tracking-[0.22em]" data-id="element-104" data-mp="86rau3sktuo1">
          <HourglassIcon className="h-5 w-5 shrink-0 text-blush" aria-hidden="true" style={{
          width: "17px",
          height: "19px"
        }} data-id="element-105" data-mp="hywyj1bsppxf" />
          <span style={{
          fontSize: "8px"
        }} data-id="element-106" data-mp="d5u3eorde8f4">L'offre expire dans :</span>
        </p>

        <p className="flex shrink-0 items-baseline gap-1.5 sm:gap-2.5" data-id="element-107" data-mp="3llw1h8srrddp">
          <Unit value={mm} label="Min" data-id="element-108" data-mp="3gnug2h7vf1z2" />
          <span className="text-xl font-black text-blush" data-id="element-109" data-mp="3gmt3g8b7i7f8">:</span>
          <Unit value={ss} label="Sec" data-id="element-110" data-mp="1kkzhqy13r8yy" />
        </p>
      </div>
    </div>;
}